import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

export const apiRequestPetCollect = async (
  params: any,
  accessToken: string,
): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/admin/petcollect/register`;

  try {
    const response = await axios.post(url, params, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
